import { render } from "./EdicionProducto.vue?vue&type=template&id=68dc58fa&scoped=true"
import script from "./EdicionProducto.js?vue&type=script&lang=js"
export * from "./EdicionProducto.js?vue&type=script&lang=js"

import "./EdicionProducto.vue?vue&type=style&index=0&id=68dc58fa&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dc58fa"]])

export default __exports__